import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './Avatar.scss';

var Avatar = /*#__PURE__*/function (_Component) {
  _inherits(Avatar, _Component);

  var _super = _createSuper(Avatar);

  function Avatar() {
    var _this;

    _classCallCheck(this, Avatar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "backgroundColors", ['#3d348b', '#e6af2e', '#93a8ac', '#9b6a6c', '#483c46', '#9e7b9b', '#6abea7', '#5e6973', '#f87060', '#b3a394']);

    _defineProperty(_assertThisInitialized(_this), "getBackgroundColor", function (username) {
      return (// Picks a background color from our list based on the character code of the first character
        // of the username that is passed in.
        _this.backgroundColors[username.charCodeAt(0) % _this.backgroundColors.length]
      );
    });

    return _this;
  }

  _createClass(Avatar, [{
    key: "render",
    value: function render() {
      var initials = this.props.username.split(' ').map(function (str) {
        return str && str.length ? str[0].toUpperCase() : '';
      }).join('');
      var innerElement = !this.props.imageUrl ? /*#__PURE__*/React.createElement("span", null, initials) : null;
      var imageStyle = this.props.imageUrl ? {
        backgroundImage: "url(".concat(this.props.imageUrl, ")")
      } : {
        backgroundColor: this.getBackgroundColor(this.props.username)
      };
      var style = Object.assign({}, this.props.avatarStyle, imageStyle);
      return /*#__PURE__*/React.createElement("div", {
        className: styles.avatar,
        style: style
      }, innerElement);
    }
  }]);

  return Avatar;
}(Component);

_defineProperty(Avatar, "propTypes", {
  imageUrl: PropTypes.string,
  username: PropTypes.string
});

_defineProperty(Avatar, "defaultProps", {
  username: ' ',
  avatarStyle: {
    color: 'pink'
  }
});

export { Avatar as default };